import { PropsModel } from "./interface/common.interface";

// Axios Setup
export const AXIOS_CREATE: PropsModel = {
  timeout: Number(process.env.VUE_APP_REQ_TIMEOUT),
  headers: {
    "Content-Type": "application/json",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
    "Content-Security-Policy": "default-src https",
    "X-Frame-Options": "DENY",
    "X-Content-Type-Options": "nosniff always",
    "Referrer-Policy": "no-referrer",
    "Permissions-Policy":
      "accelerometer=(), ambient-light-sensor=(), autoplay=(), battery=(), camera=(), cross-origin-isolated=(), display-capture=(), document-domain=(), encrypted-media=(), execution-while-not-rendered=(), execution-while-out-of-viewport=(), fullscreen=(), geolocation=(), gyroscope=(), keyboard-map=(), magnetometer=(), microphone=(), midi=(), navigation-override=(), payment=(), picture-in-picture=(), publickey-credentials-get=(), screen-wake-lock=(), sync-xhr=(), usb=(), web-share=(), xr-spatial-tracking=()",
  },
};

export const DECIMAL_PLACES_CURRENCY = 2;

export const MAX_FILE_SIZE = 25000000;

export const PAGE_SIZE_OPTIONS = [
  "10",
  "25",
  "50",
  "100",
  "150",
  "250",
  "300",
  "500",
  "750",
  "1000",
] as const;
export const SHORT_PAGE_SIZE_OPTIONS = ["10", "25", "50", "100", "200"] as const;

export const MONTH_OPTIONS = [
  { value: 1, labelKey: "lbl_january" },
  { value: 2, labelKey: "lbl_february" },
  { value: 3, labelKey: "lbl_march" },
  { value: 4, labelKey: "lbl_april" },
  { value: 5, labelKey: "lbl_may" },
  { value: 6, labelKey: "lbl_june" },
  { value: 7, labelKey: "lbl_july" },
  { value: 8, labelKey: "lbl_august" },
  { value: 9, labelKey: "lbl_september" },
  { value: 10, labelKey: "lbl_october" },
  { value: 11, labelKey: "lbl_november" },
  { value: 12, labelKey: "lbl_december" },
] as const;

export const TOTAL_QUARTERS = 4;

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 10;

export const ONE = 1;

export const MAX_LENGTH_CHARACTER = 5000;
